import { VotingConstants } from "../../constants/voting.constants";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import { message } from "antd";
import moment from 'moment';

// const uri = "/Voting";
const fromDateDefault = moment('2018-01-01').utc().format();
const toDateDefault = moment().utc().format();

const uri = `/Voting?fromDate=${fromDateDefault}&toDate=${toDateDefault}`;

export const getAllVoting = (onlyActive, sort) => async (dispatch) => {
	try {
		dispatch({
			type: VotingConstants.GET_ALL_VOTING,
		});
		const response = await client.get(uri, {
			headers: authHeader()
		});
		let result = response.data;
		if (onlyActive) {
			result = result.filter((voting) => voting.state.id === 2);
		}
		if (sort === "active" && !onlyActive) {
			result = result.sort((voting, nextVoting) => {
				const firstIsActive = voting.state.id === 2;
				const secondIsActive = nextVoting.state.id === 2;
				if (firstIsActive && !secondIsActive) {
					return -1;
				}
				if (!firstIsActive && secondIsActive) {
					return 1;
				}
				return 0;
			});
		}
		if (sort === "old") {
			result = result.sort((voting, nextVoting) => {
				if (voting.createDate < nextVoting.createDate) {
					return -1;
				}
				if (voting.createDate > nextVoting.createDate) {
					return 1;
				}
				return 0;
			});
		}
		if (sort === "recently") {
			result = result.sort((voting, nextVoting) => {
				if (voting.createDate > nextVoting.createDate) {
					return -1;
				}
				if (voting.createDate < nextVoting.createDate) {
					return 1;
				}
				return 0;
			});
		}
		return dispatch({
			type: VotingConstants.GET_ALL_VOTING_SUCCESS,
			payload: [...result],
		});
	} catch (e) {
		console.error(e);
		message.error("Не получилось загрузить список опросов, попробуйте позже");
	}
};
